module.exports = __webpack_public_path__ + "static/media/termopary8kz.05bfae91.pdf";